export default __webpack_public_path__ + "static/media/6.905732e5.jpg";